import React from 'react';
import PropTypes from 'prop-types';

import {ErrorMessage, Field, Form} from 'formik';

import {ExpandableSectionsLayout,} from 'pac-platform-ui-components';


import {Box, Group, SimpleGrid} from '@mantine/core';

import SubmitFormGroup from 'components/SubmitFormGroup';

import SSOCustomerAgreement from '../components/SSOCustomerAgreement';
import TermsOfUseDocument from '../components/TermsOfUseDocument';

const agreements = [
    {
        id: 'sso',
        title: 'SSO (Single Sign On) Agreement',
        path: '/some-path',
        element: <SSOCustomerAgreement/>,
    },
    {
        id: 'terms',
        title: 'Terms of Use',
        path: '/some-path',
        element: <TermsOfUseDocument/>,
    },
];

const sections = [
    {
        title: 'SSO (Single Sign On) Agreement',
        component: <SSOCustomerAgreement/>,
        defaultExpanded: true,
    },
    {
        title: 'Terms Of Use',
        component: <TermsOfUseDocument/>,
        defaultExpanded: true,
    },
];

const firstSection = [
    {
        title: 'SSO (Single Sign On) Agreement',
        component: <SSOCustomerAgreement/>,
    },
];

const CustomErrorComponent = ({children}) => {
    return (
        <Box color="text-status-error" mt="sm">
            {children}
        </Box>
    );
};

CustomErrorComponent.propTypes = {
    children: PropTypes.string,
};

const FormLineItem = ({id, title}) => {
    return (
        <Group>
            <Box px="sm">
                <Field id={id} type="checkbox" name={id}/>
            </Box>
            <label htmlFor={id}>I Agree to the {title}</label>
            <ErrorMessage name={id} component={CustomErrorComponent}/>
        </Group>
    );
};

const FormComponent = (props) => (
    <Form onSubmit={props.handleSubmit}>
        <SimpleGrid>
            {/*
            <ExpandableSectionsLayout sections={sections} />
            */}

            <ExpandableSectionsLayout sections={sections}/>

            {agreements.map((item) => {
                return (
                    <React.Fragment key={item.id}>
                        <FormLineItem
                            key={item.id}
                            id={item.id}
                            title={item.title}
                            element={item.element}
                        />
                    </React.Fragment>
                );
            })}

            <SubmitFormGroup
                cancelUrl="/"
                disabled={props.isSubmitting}
                submitButtonLabel="Submit"
            />
        </SimpleGrid>
    </Form>
);

export default FormComponent;

FormComponent.propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
};

FormLineItem.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string,
};
